<template>
    <div>
        <h1 class="mt-2 mb-4">Каталог документов</h1>
        <div class="mb-4" style="display: flex; justify-content: space-between; align-items: center;">
            <IconField style="flex-grow: 1;">
                <InputIcon class="pi pi-search" />
                <InputText v-model="searchQuery" placeholder="Поиск документов" @input="searchDocuments"
                    style="width: 100%;" />
            </IconField>
        </div>
        <div class="mb-4" style="display: flex; gap: 10px; flex-wrap: wrap; align-items: center;">
            Категории: 
            <PrimeButton v-for="category in categories" size="small" rounded :key="category._id" @click="filterByCategory(category._id)"
                :label="category.name" :aria-pressed="selectedCategory === category._id" :class="{'category-selected': selectedCategory === category._id}" class="document-category p-button-outlined p-button-secondary">
                <template #icon>
                    <span v-if="selectedCategory === category._id" class="pi pi-check"></span>
                </template>
            </PrimeButton>

        </div>
        <div v-if="loading" class="loading-spinner">
            <ProgressSpinner />
        </div>
        <div style="display: flex; align-items: center;">
                <span>Вид:</span>
                <p-toggle-switch v-model="isGridView" onLabel="Плитки" offLabel="Список" aria-label="Показывать документы плитками" class="ml-2" />
        </div>
        <div v-if="isGridView" class="viewers-list mt-2 flex flex-wrap gap-3 md:gap-4 xl:gap-4">
            <div class="document" @mouseover="hover(document._id)" @mouseleave="leave" v-for="document in documents"
                :key="document._id">
                <router-link :to="'/catalog/' + document._id" class="text-decoration-none">
                    <div v-if="hovered !== document._id">
                        <div
                            class="document-icon-wrapper d-inline-flex justify-content-center align-items-center mb-2 w-full">
                            <div class="line"></div>
                            <div class="icon">
                                <i class="pi pi-file-word document-icon"></i>
                            </div>
                            <div class="line"></div>
                        </div>
                        <div class="document-name text-center">{{ document.title }}</div>
                    </div>
                    <div v-else>
                        <div class="open-button">Открыть</div>
                    </div>
                </router-link>
            </div>
        </div>
        <div v-else class="list-view mt-4">
            <div class="document-list-item" v-for="document in documents" :key="document._id">
                <router-link :to="'/catalog/' + document._id" class="text-decoration-none d-flex align-items-center">
                    <i class="pi pi-file-word document-icon-small mr-2"></i>
                    <div>{{ document.title }}</div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import http from "@/http";
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import ProgressSpinner from 'primevue/progressspinner';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import pToggleSwitch from 'primevue/togglebutton';  // Исправляем путь импорта

export default {
    components: {
        InputText,
        IconField,
        InputIcon,
        PrimeButton: Button,
        ProgressSpinner,
        pToggleSwitch
    },
    data() {
        return {
            documents: [],
            allDocuments: [],  // Для хранения всех документов
            categories: [],
            searchQuery: '',
            loading: false,
            hovered: null,
            selectedCategory: 'all',  // По умолчанию выбрана категория "Все"
            isGridView: true  // Режим отображения: плитка (true) или строка (false)
        };
    },
    async created() {
        await this.fetchCategories();
        await this.fetchAllDocuments();  // Загружаем все документы при инициализации
    },
    methods: {
        async fetchAllDocuments() {
            try {
                this.loading = true;
                const response = await http.get('catalog/document_files');  // Получаем все документы
                this.allDocuments = response.data;  // Сохраняем все документы для локальной фильтрации
                this.documents = this.allDocuments;  // Отображаем все документы при загрузке компонента
            } catch (error) {
                console.error("Error fetching all documents:", error);
            } finally {
                this.loading = false;
            }
        },
        async fetchCategories() {
            try {
                const response = await http.get('catalog/document_categories');
                this.categories = [{ _id: 'all', name: 'Все' }, ...response.data];  // Добавляем категорию "Все" первой
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        },
        filterByCategory(category_id) {
            this.selectedCategory = category_id;

            if (category_id === 'all') {
                this.documents = this.allDocuments;  // Если выбрана категория "Все", показываем все документы
            } else {
                this.documents = this.allDocuments.filter(document => document.category_id === category_id);  // Фильтруем документы по выбранной категории
            }
        },
        async searchDocuments() {
            if (!this.searchQuery) {
                this.filterByCategory(this.selectedCategory);  // При пустом поиске показываем документы выбранной категории
                return;
            }

            try {
                this.loading = true;
                const response = await http.get('catalog/document_files/search', { params: { query: this.searchQuery } });
                this.documents = response.data;
            } catch (error) {
                console.error("Error searching documents:", error);
            } finally {
                this.loading = false;
            }
        },
        hover(id) {
            this.hovered = id;
        },
        leave() {
            this.hovered = null;
        },
    },
};
</script>

<style scoped>
.loading-spinner {
    text-align: center;
    padding: 2rem;
}

.viewers-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 30px !important;
}

.document {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 300px;
    height: 150px;
    padding: 20px;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
    margin-bottom: 15px;
    transition: background-color 0.3s ease;
}

.document:hover {
    background-color: #e8f8ff;
}

.document-icon-wrapper,
.document-name,
.open-button {
    transition: opacity 0.3s ease;
}

.document-icon-wrapper .line {
    width: 35px;
    height: 1px;
    background: rgba(39, 39, 85, 0.1);
    border-radius: 100px;
    border: 1px solid rgba(39, 39, 85, 0.1);
}

.document-name {
    color: #5f5f5f;
    font-family: Nunito;
    font-size: 14px;
    font-weight: 500;
    margin-top: 15px;
}

.icon {
    display: inline-flex;
    width: 40px;
    height: 40px;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    margin-left: 15px;
    margin-right: 15px;
}

.document-icon {
    font-size: 40px;
    color: #3fe7de;
}

.open-button {
    background-color: white;
    opacity: 0;
    color: rgb(66, 66, 79);
    padding: 10px;
    border-radius: 10px;
    padding-left: 20px;
    padding-right: 20px;
}

.document:hover .open-button {
    opacity: 1;
}

.document:hover .document-icon-wrapper,
.document:hover .document-name {
    opacity: 0;
}

@media (min-width: 1200px) {
    .document {
        flex: 1 1 calc(33.333% - 20px);
    }
}

@media (min-width: 768px) and (max-width: 1199px) {
    .document {
        flex: 1 1 calc(50% - 20px);
    }
}

@media (max-width: 767px) {
    .document {
        flex: 1 1 100%;
    }
}

.list-view {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.document-list-item {
    display: flex;
    align-items: center;
    padding: 10px;
    border-radius: 5px;
    background: #fff;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
    transition: background-color 0.3s ease;
}

.document-list-item:hover {
    background-color: #e8f8ff;
}

.document-icon-small {
    font-size: 20px;
    color: #3fe7de;
    margin-right: 10px;
}
</style>
